import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Button } from '../ui/button';


const StepOne = ({ onNextStep, appointmentBooking }) => {
    const { control, handleSubmit, formState: { errors } } = useFormContext();

    const onSubmit = (data) => {
        onNextStep(data); // Pass the data to the parent component (MultiStepForm)
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Controller
                name="name"
                control={control}
                defaultValue=""
                rules={{
                    required: appointmentBooking.validation.name1,
                    pattern: {
                        value: /^[A-Za-z\s\u0900-\u097F]+$/,
                        message: appointmentBooking.validation.name3,
                    },
                    minLength: { value: 2, message: appointmentBooking.validation.name1 },
                    maxLength: { value: 20, message: appointmentBooking.validation.name2 }, 
                }}
                render={({ field }) => (
                    <div className='mb-4 relative'>
                        <Label className='text-primaryWhite p-text'>{appointmentBooking.name}*</Label>
                        <Input
                            type="text"
                            {...field}
                            placeholder={appointmentBooking.name}
                            className=' focus-visible:ring-offset-0 bg-blue-50 w-full h-10 px-3 text-primaryGreyText'
                        />
                        {errors.name && <span className='text-xs text-primaryRed absolute'>{errors.name.message}</span>}
                    </div>
                )}
            />
            <Controller
                name="email"
                control={control}
                defaultValue=""
                rules={{
                    required: appointmentBooking.validation.email2,
                    pattern: {
                        value: /^\S+@\S+$/i,
                        message: appointmentBooking.validation.email2,
                    },
                }}
                render={({ field }) => (
                    <div className='mb-4 relative'>
                        <Label className='text-primaryWhite p-text'>{appointmentBooking.mail}*</Label>
                        <Input
                            type="email"
                            {...field}
                            placeholder={appointmentBooking.mail}
                            className=' focus-visible:ring-offset-0 bg-blue-50 w-full h-10 px-3 text-primaryGreyText'
                        />
                        {errors.email && <span className='text-xs text-primaryRed absolute mb-2'>{errors.email.message}</span>}
                    </div>
                )}
            />
            <Controller
                name="phone"
                control={control}
                defaultValue=""
                rules={{
                    required: appointmentBooking.validation.phone,
                    pattern: {
                        value: /^\d{10}$/,
                        message: appointmentBooking.validation.phone,
                    },
                }}
                render={({ field }) => (
                    <div className='mb-4 relative'>
                        <Label className='text-primaryWhite p-text'>{appointmentBooking.phone}*</Label>
                        <Input
                            type="tel"
                            {...field}
                            placeholder={appointmentBooking.phone}
                            className=' focus-visible:ring-offset-0 bg-blue-50 w-full h-10 px-3 text-primaryGreyText'
                        />
                        {errors.phone && <span className='text-xs text-primaryRed absolute mb-2'>{errors.phone.message}</span>}
                    </div>
                )}
            />
            <div className='text-end mt-8'>
            <Button type="submit" variant ='outline' className='mt-3 rounded-3xl w-32 bg-primaryWhite text-primaryBlue uppercase stepone_nextbtn'>{appointmentBooking.next}</Button>
            </div>
        </form>
    );
};

export default StepOne;
